<script lang="ts">
	import { setContext } from "svelte";
	import Filters from "./Filters.svelte";
	import HeroList from "./HeroList.svelte";
	import Pagination from "./Pagination.svelte";
	import Loader from "./Loader.svelte";

	import HeroesApi from "./api/HeroesApi";
	import type Hero from "./api/Hero";
	import type { IResponseHeroes } from "./api/IResponse";

	export let PageID: number = 4702;
	export let ModuleID: number = 14422;
	export let MediaPath: string = "";
	export let apiDomain: string = "http://tmd.i7demo.com/";
	export let noResultMessage = "No results found. Try different search parameters.";

	setContext("PageID", PageID);
	setContext("ModuleID", ModuleID);

	const api: HeroesApi = new HeroesApi(PageID, ModuleID, apiDomain);
	let heroes: Array<Hero> = [];
	let page: number = 1;
	let pageCount: number = 0;
	let totalCount: number = 0;
	let showEditLinks: boolean = false;

	let optionsPayGrade: Array<string> = [];
	// let optionsRank: Array<string> = [];
	let optionsComponent: Array<string> = [];

	let filterResults;

	let loading: boolean = true;

	// Initialize App
	api.MediaPath = MediaPath;
	api.Request.Pagination.Take = 12;
	api.Request.Pagination.Skip = 0;

	async function init() {
		const payGrade = api.GetFields("PayGrade");
		// const rank = api.GetFields("Rank");
		const component = api.GetFields("Component");

		const loaded = await Promise.all([
			api.Fetch(),
			payGrade,
			// rank,
			component,
		]);

		optionsPayGrade = loaded[1].data.values;
		// optionsRank = loaded[2].data.values;
		optionsComponent = loaded[2].data.values;
		loading = false;
	}

	init();

	api.OnResult((payload: IResponseHeroes) => {
		heroes = payload.data.heroes;
		page = payload.data.page;
		pageCount = payload.data.pageCount;
		totalCount = payload.data.totalCount;
		showEditLinks = payload.data.showEditLinks;
		loading = false;
	});

	$: firstItem =
		page * api.Request.Pagination.Take - api.Request.Pagination.Take + 1;
	$: lastItem = Math.min(page * api.Request.Pagination.Take, totalCount);

	function filterUpdate(e) {
		const { key, value } = e.detail;

		api.Update("Filter", key, value);
		loading = true;
	}

	function paginationUpdate(e) {
		const { key, value } = e;

		api.Update(
			"Pagination",
			key,
			(value - 1) * api.Request.Pagination.Take
		);
		loading = true;

		filterResults.scrollIntoView({ behavior: "smooth" });
	}
</script>

<div class:heroes-loading={loading}>
	{#if loading}
		<Loader />
	{/if}

	<Filters on:change={filterUpdate} {optionsPayGrade} {optionsComponent} />

	<div class="results row" bind:this={filterResults}>
		<div class="col-md-6">
			{#if heroes.length === 0}
				<p>{noResultMessage}</p>
			{/if}
		</div>
		<div class="col-md-6 text-right">
			<small>
				Showing {firstItem} to {lastItem} of {totalCount} results.
			</small>
		</div>
	</div>

	<HeroList {heroes} {showEditLinks} />

	<Pagination
		bind:total={pageCount}
		bind:currentPage={page}
		on:navigated={(e) => paginationUpdate({ key: "Skip", value: e.detail })}
	/>
</div>

<style>
	.results {
		margin-bottom: 15px;
	}

	.heroes-loading {
		position: relative;
		pointer-events: none;
	}

	.heroes-loading > :global(*) {
		opacity: 0.2;
	}
</style>
